import { useRef, useEffect, useState } from "react"
import { Link } from "react-router-dom"
import ProductList from "./ProductList"
// 1. Sửa import: Dùng ProductItem thay vì CartItem
import { ProductItem } from "../../api/QuickOrder"

interface LeftContentProps {
    // 2. Cập nhật type cho props
    cartItems: ProductItem[];
    loading: boolean;
    onUpdateQuantity: (id: number, qty: number) => void;
    page: number;
    totalPage: number;
    setPage: (page: number) => void;
    searchText: string;
    onSearchChange: (text: string) => void;
}

const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount);
}

export default function LeftContentQuickOrder({ cartItems, loading, onUpdateQuantity, page, totalPage, setPage, searchText, onSearchChange }: LeftContentProps) {
    const siblingCount = 2

    const getVisiblePageItems = (): Array<number | "ellipsis-left" | "ellipsis-right"> => {
        const start = Math.max(1, page - siblingCount)
        const end = Math.min(totalPage, page + siblingCount)
        const items: Array<number | "ellipsis-left" | "ellipsis-right"> = []

        if (start > 1) {
            items.push(1)
            if (start > 2) items.push("ellipsis-left")
        }

        for (let p = start; p <= end; p += 1) {
            items.push(p)
        }

        if (end < totalPage) {
            if (end < totalPage - 1) items.push("ellipsis-right")
            items.push(totalPage)
        }

        return items
    }

    const pageItems = getVisiblePageItems()

    const goPrev = () => {
        if (page > 1) setPage(page - 1)
    }

    const goNext = () => {
        if (page < totalPage) setPage(page + 1)
    }

    return (
        <div className="styles_containerProducts__MMWm5">
            <header className="MuiPaper-root MuiAppBar-root MuiAppBar-positionFixed MuiAppBar-colorPrimary styles_appBar__Kzodx mui-fixed MuiPaper-elevation4 w-full-1199-24px show-1199">
                <div className="MuiToolbar-root MuiToolbar-regular styles_toolBar__DQTee MuiToolbar-gutters">
                    <Link to="/" className="MuiButtonBase-root MuiButton-root MuiButton-text styles_btnHamburger__POqzB" aria-label="back pagehome">
                        <span className="MuiButton-label">
                            <span style={{ boxSizing: "border-box", display: "inline-block", overflow: "hidden", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", position: "relative", maxWidth: "100%" }}>
                                <span style={{ boxSizing: "border-box", display: "block", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px", maxWidth: "100%" }}>
                                    <img alt="" aria-hidden="true" src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2724%27%20height=%2724%27/%3e" style={{ display: "block", maxWidth: "100%", width: "initial", height: "initial", background: "none", opacity: 1, border: "0px", margin: "0px", padding: "0px" }} />
                                </span>
                                <img src="/theme/arrow-left.svg" decoding="async" data-nimg="intrinsic" style={{ position: "absolute", inset: "0px", boxSizing: "border-box", padding: "0px", border: "none", margin: "auto", display: "block", width: "0px", height: "0px", minWidth: "100%", maxWidth: "100%", minHeight: "100%", maxHeight: "100%" }} />
                            </span>
                        </span>
                        <span className="MuiTouchRipple-root"></span>
                    </Link>
                    <p className="MuiTypography-root styles_formTitle__o8AZx MuiTypography-body1">Đặt hàng nhanh</p>
                </div>
            </header>
            <div className="styles_searchWrapper__1VsnB">
                <div className="MuiInputBase-root MuiInput-root styles_root_input__fUHE5 MuiInputBase-adornedStart">
                    <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1a5basm" focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="SearchIcon">
                        <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                    </svg>
                    <input placeholder="Nhập tên thuốc, hoạt chất cần tìm" type="search" className="MuiInputBase-input MuiInput-input styles_input__p8e0Z MuiInputBase-inputAdornedStart MuiInputBase-inputTypeSearch MuiInput-inputTypeSearch" value={searchText} onChange={(e) => onSearchChange(e.target.value)} />
                </div>
            </div>
            <div style={{ margin: "8px 0px", fontStyle: "italic", color: "rgb(245, 34, 45)" }}>*Giá bạn đang xem là giá đã giảm sau khi áp dụng các chương trình khuyến mãi như chiết khấu chuyển khoản và mã giảm giá</div>

            {/* ProductList đã được update để nhận ProductItem[] */}
            <ProductList cartItems={cartItems} onUpdateQuantity={onUpdateQuantity} />

            <div className="style_topPagging__fUaNu !relative">
                <div className="styles_pagiContainer__B0imj MuiBox-root css-1vwfmvr">
                    <nav
                        aria-label="pagination navigation"
                        className="MuiPagination-root jss273"
                    >
                        <ul className="MuiPagination-ul">
                            {/* PREV */}
                            <li>
                                <button
                                    className={
                                        "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                        (page === 1 ? " Mui-disabled" : "")
                                    }
                                    tabIndex={page === 1 ? -1 : 0}
                                    type="button"
                                    disabled={page === 1}
                                    aria-label="Go to previous page"
                                    onClick={goPrev}
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiPaginationItem-icon"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                                    </svg>
                                </button>
                            </li>

                            {/* PAGE NUMBERS */}
                            {pageItems.map((item, index) => {
                                if (typeof item !== "number") {
                                    return (
                                        <li key={`${item}-${index}`}>
                                            <div className="MuiPaginationItem-root MuiPaginationItem-ellipsis">
                                                ...
                                            </div>
                                        </li>
                                    )
                                }

                                return (
                                    <li key={item}>
                                        <button
                                            className={
                                                "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                                (page === item ? " Mui-selected" : "")
                                            }
                                            tabIndex={0}
                                            type="button"
                                            aria-current={page === item ? "true" : undefined}
                                            aria-label={`Go to page ${item}`}
                                            onClick={() => setPage(item)}
                                        >
                                            {item}
                                            <span className="MuiTouchRipple-root" />
                                        </button>
                                    </li>
                                )
                            })}

                            {/* NEXT */}
                            <li>
                                <button
                                    className={
                                        "MuiButtonBase-root MuiPaginationItem-root MuiPaginationItem-page" +
                                        (page >= totalPage ? " Mui-disabled" : "")
                                    }
                                    tabIndex={0}
                                    type="button"
                                    disabled={page >= totalPage}
                                    aria-label="Go to next page"
                                    onClick={goNext}
                                >
                                    <svg
                                        className="MuiSvgIcon-root MuiPaginationItem-icon"
                                        focusable="false"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                                    </svg>
                                    <span className="MuiTouchRipple-root" />
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    )
}